"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DetailToolbarButtonAction = void 0;
const react_1 = __importStar(require("react"));
const detail_action_button_1 = require("../action-button/detail/detail-action-button");
function DetailToolbarButtonAction(props) {
    react_1.useEffect(() => {
        if (process.env.NODE_ENV === 'development') {
            console.warn('DetailToolbarButtonAction is deprecated. Use DetailActionButton instead.');
        }
    }, []);
    return react_1.default.createElement(detail_action_button_1.DetailActionButton, Object.assign({}, props));
}
exports.DetailToolbarButtonAction = DetailToolbarButtonAction;
//# sourceMappingURL=detail-toolbar-button-action.js.map